cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_storecheckplanlist_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			viewmodel.on("afterInit", function() {
				//单据日期默认值
				var currentDate = new Date().format('yyyy-MM-dd');
				var startDate = currentDate.substr(0, currentDate.length - 2) + '01';
				viewmodel.get('vouchdate').getFromModel().setValue(startDate);
				viewmodel.get('vouchdate').getToModel().setValue(currentDate);

				if(viewmodel.get('warehouse')) {
					//仓库默认值
//					var queryWarehProxy = cb.rest.DynamicProxy.create({
//						settle: {
//							url: '/billingretail/getDefaultWareh',
//							method: 'POST',
//							options: {
//								async: false
//							}
//						}
//					});
//					var data = queryWarehProxy.settle();
//					viewmodel.get('warehouse').getFromModel().setValue([data.result]);


					//盘点仓库过滤条件
					var condition = {
						"isExtend": true,
						simpleVOs: []
					};
					var storeid = cb.rest.AppContext.user.storeId;
					condition.simpleVOs.push({
						field: 'store',
						op: 'eq',
						value1: storeid
					});
					viewmodel.get('warehouse').getFromModel().setFilter(condition);

				}

			});

			viewmodel.on("beforeSearch", function(condition) {
				//				debugger
				//两次，第一次是获取到盘点复核列表的viewmodel，继续获取父亲，才获取到盘点计划的viewmodel
				//				parentViewModel = viewmodel.getCache('parentViewModel').getCache('parentViewModel');
				//				if(!condition.simpleVOs) {
				//					condition.simpleVOs = [];
				//				}
				//				condition.simpleVOs.push({
				//					field: 'id',
				//					op: 'eq',
				//					value1: parentViewModel.get('id').getValue()
				//				});
				//				//默认按照存量看漏盘
				//				condition.simpleVOs.push({
				//					field: 'resultdetails.stockbasis',
				//					op: 'eq',
				//					value1: '1'
				//				});
				//				condition['isExtend'] = true;
			});
		}

	}
	try {
		module.exports = ST_st_storecheckplanlist_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_storecheckplanlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storecheckplanlist_filterVM.Extend.js